import { combine } from '../ui'

/**
 * Get address
 * @param value
 * @returns {string}
 */
export const getAddress = (value) => {
  const address = combine([value.address1, value.address2, value.address3])
  const city = combine([value.city, value.state_province])
  const country = combine([value.country_name, value.postal_code], ' ')

  return combine([address, city, country], '<br>')
}

/**
 * Get phones
 * @param phone
 * @param direct
 * @returns {string}
 */
export const getPhones = (phone, direct) => {
  const corporatePhone = (phone && phone.length) ? phone : null
  const directPhone = (direct && direct.length) ? `${direct} (direct)` : null

  if (corporatePhone && directPhone && (corporatePhone !== directPhone)) {
    return combine([corporatePhone, directPhone], '<br>')
  }

  return corporatePhone || directPhone
}

/**
 * Get strategy by institution id
 * @param value
 * @returns {string}
 */
export const getStrategy = (value) => {
  if (!value) {
    return '-'
  }

  if (value.summary && value.summary.length) {
    return value.summary
  }

  const country = combine(value.country)
  const regionGroup = combine(value.region_group)
  const customRegion = combine(value.custom_region)
  const marketCap = combine(value.market_cap)
  const quality = combine(value.quality)
  const sectors = combine(value.sectors)
  const strategy = combine(value.strategy)
  const style = combine(value.style)
  const securityType = combine(value.security_type)

  return combine([country, regionGroup, customRegion, marketCap, quality, sectors, strategy, style, securityType])
}
